import { Ng2StateDeclaration, UIRouter } from '@uirouter/angular';

export const airModules: Ng2StateDeclaration = {
    name: 'airmodules_a.**',
    url: '/airmodules',
    loadChildren: () => import('./root/airModules.root.module').then(m => m.AirModulesRootModule),
};

export function airModulesStateConfigFn(router: UIRouter) {
  router.urlService.rules.when("/airmodules_a", "/airmodules");
  router.urlService.rules.when("/airmodules_a/", "/airmodules");
  router.urlService.rules.when("/airmodules/", "/airmodules");
}
